import { IconButton, IconButtonProps } from "@chakra-ui/react";
import { FaArrowDown, FaArrowUp } from "react-icons/fa";

export enum Direction {
  Up,
  Down,
}

export interface NavigationArrowProps
  extends Omit<IconButtonProps, "variant" | "aria-label"> {
  variant: Direction;
}

function getIcon(variant: Direction) {
  switch (variant) {
    case Direction.Up:
      return { buttonIcon: <FaArrowUp />, ariaLabel: "Scroll Up" };
    case Direction.Down:
      return { buttonIcon: <FaArrowDown />, ariaLabel: "Scroll Down" };
  }
}

export const NavigationArrow = (props: NavigationArrowProps) => {
  const { variant, ...rest } = props;

  const { buttonIcon, ariaLabel } = getIcon(variant);

  return (
    <IconButton
      icon={buttonIcon}
      aria-label={ariaLabel}
      _hover={{
        textDecoration: "none",
      }}
      _focus={{
        outline: "none",
        boxShadow: "none",
      }}
      boxShadow="lg"
      size="lg"
      rounded="full"
      cursor="pointer"
      {...rest}
    />
  );
};
